import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const logoSrc = '/Emblem_of_Goa_Police.png';

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Hide nav on auth page
  if (['/login', '/signup', '/'].includes(location.pathname)) {
    return null;
  }

  const navItems = [
    { path: '/home', label: 'Dashboard' },
    { path: '/telegram-search', label: 'Discover' },
    { path: '/auto-scan', label: 'AutoScan' },
    { path: '/publicReport', label: 'Live Reports' },
    { path: '/fraud', label: 'Reviewed DB' },
    { path: '/settings', label: 'Settings' }
  ];

  const handleLogout = async () => {
    await signOut(auth);
    setMenuOpen(false);
    navigate('/login');
  };

  return (
    <>
      <nav className="main-nav">
        <div className="main-nav__brand">
          <Link to="/home" className="main-nav__brand-link" aria-label="Go to dashboard home">
            <img src={logoSrc} alt="Goa Police Emblem" className="main-nav__brand-logo" />
            <span>Cyber Vigil</span>
          </Link>
        </div>

        <div className="main-nav__links" aria-label="Primary navigation">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`main-nav__link ${location.pathname === item.path ? 'is-active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="main-nav__actions">
          <button onClick={handleLogout} className="main-nav__logout" type="button">
            Logout
          </button>
        </div>

        <button
          type="button"
          className="main-nav__menu-btn"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? 'Close' : 'Menu'}
        </button>
      </nav>

      <div
        className={`mobile-nav-overlay ${menuOpen ? 'is-open' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden={!menuOpen}
      />

      <aside className={`mobile-sidebar ${menuOpen ? 'is-open' : ''}`} aria-label="Mobile sidebar">
        <div className="mobile-sidebar__head">
          <div className="mobile-sidebar__brand">
            <img src={logoSrc} alt="Goa Police Emblem" className="mobile-sidebar__brand-logo" />
            <span>Cyber Vigil</span>
          </div>
          <button type="button" className="mobile-sidebar__close" onClick={() => setMenuOpen(false)}>
            Close
          </button>
        </div>

        <div className="mobile-sidebar__email">{auth.currentUser?.email || 'Officer'}</div>

        <div className="mobile-sidebar__links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-sidebar__link ${location.pathname === item.path ? 'is-active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <button onClick={handleLogout} className="mobile-sidebar__logout" type="button">
          Logout
        </button>
      </aside>
    </>
  );
}
